import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';

import { FormGroup, Label, Input, FormFeedback, FormText, Button } from 'reactstrap';

import hide from '../../../assets/svg/hide.svg';
import show from '../../../assets/svg/show.svg';
import striptags from 'striptags';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import garabage from '../../../assets/svg/garbage.svg'


class ConfigurableItems extends Component {
    constructor(props) {
        super(props);

        this.state = {
            itemValue: {
                buttonText: '',
                link: ''
            },
            error: {
                buttonText: false,
                link: false
            }
        };
    }


    componentDidMount() {
    }

    onAddHandle = () => {

        let value = this.props.value ? this.props.value : [];
        const itemValue = this.state.itemValue ? {
            buttonText: this.state.itemValue.buttonText ? this.state.itemValue.buttonText.trim() : '',
            link: this.state.itemValue.link ? this.state.itemValue.link.trim() : ''
        } : {};

        let error = {
            buttonText: false,
            link: false
        }
        if (!itemValue?.buttonText) {
            error.buttonText = true;
        }
        if (!itemValue?.link) {
            error.link = true;
        }
        if (error.buttonText || error.link) {
            this.setState({ error });
            return;
        }

        value.push(itemValue);
        this.setState({
            itemValue: {
                buttonText: '',
                link: ''
            },
            error: {
                buttonText: false,
                link: false
            }
        });
        this.props.onChange(value);
    }
    removeFromList = (index) => {
        let value = this.props.value ? this.props.value : [];
        if (index >= 0 && index < value.length) {
            value.splice(index, 1);
            if (value?.length === 0) {
                value = null;
            }
            this.props.onChange(value);
            this.setState({ refresh: new Date().getTime() });
        }
    }
    render() {
        return (
            <FormGroup className='configurable-items-form-group'>
                {this.props.label ?
                    <Label size="sm" className={this.props.error ? "required form-group-label-wrap" : "form-group-label-wrap"}>
                        {this.props.label}{this.props.haveValidation ? <span className="required-label-span">*</span> : null}
                        {
                            this.props.labelInfo ?
                                <div className='info'>
                                    <Isvg src={infoIcon} />
                                    <div className="info-text">{this.props.labelInfo}</div>
                                </div>
                                :
                                null
                        }
                    </Label>
                    :
                    null}
                <div className='configurable-item-input-wrap'>
                    <Input
                        style={{ height: this.props.height ? this.props.height : null, width: this.props.width ? this.props.width : null, border: this.state.error?.buttonText ? '1px solid red' : null }}
                        // onKeyPress={(e) => {
                        //     if (e.key === 'Enter') {
                        //         e.preventDefault();
                        //         this.onAddHandle();
                        //     }
                        // }}
                        size="sm"
                        disabled={this.props.disabled}
                        name={this.props.name}
                        invalid={this.state.error?.buttonText ? true : false}
                        type={'text'}
                        onChange={(e) => {
                            const value = e.target.value;
                            let itemValue = this.state.itemValue ?? {};
                            itemValue.buttonText = value;
                            let setObj = {
                                itemValue
                            }
                            if (this.state.error?.buttonText) {
                                let error = this.state.error;
                                error.buttonText = false;
                                setObj.error = error;
                            }
                            this.setState(setObj);
                        }}
                        value={this.state.itemValue?.buttonText}
                        placeholder={'Button text'.translate(this.props.lang)}
                    >
                        {this.props.children}
                    </Input>
                    <Input
                        style={{ height: this.props.height ? this.props.height : null, width: this.props.width ? this.props.width : null, border: this.state.error?.link ? '1px solid red' : null }}
                        // onKeyPress={(e) => {
                        //     if (e.key === 'Enter') {
                        //         e.preventDefault();
                        //         this.onAddHandle();
                        //     }
                        // }}
                        size="sm"
                        disabled={this.props.disabled}
                        name={this.props.name}
                        invalid={this.state.error?.link ? true : false}
                        type={'text'}
                        onChange={(e) => {
                            const value = e.target.value;
                            let itemValue = this.state.itemValue ?? {};
                            itemValue.link = value;
                            let setObj = {
                                itemValue
                            }
                            if (this.state.error?.link) {
                                let error = this.state.error;
                                error.link = false;
                                setObj.error = error;
                            }
                            this.setState(setObj);

                        }}
                        value={this.state.itemValue?.link}
                        placeholder={'Link'.translate(this.props.lang)}
                    >
                        {this.props.children}
                    </Input>

                    <Button color='primary' onClick={() => this.onAddHandle()}>{'Add'.translate(this.props.lang)}</Button>

                </div>
                <div className='configurable-items-list'>
                    {
                        this.props.value?.length === 0 ?
                            <div className='empty-list-message'>{'No added items yet!'.translate(this.props.lang)}</div>
                            :
                            <div>
                                {
                                    this.props.value.map((item, index) => {
                                        return (
                                            <div key={index} className='configurable-item'>
                                                <span className='item-text'>{item?.buttonText} - {item?.link}</span>
                                                <Button className='remove-item-btn' size='sm' onClick={() => {
                                                    this.removeFromList(index);
                                                }}><Isvg src={garabage} /></Button>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                    }
                </div>
                {this.props.error ? <FormFeedback >{this.props.error}</FormFeedback> : null}
            </FormGroup >
        );
    }
}

export default ConfigurableItems;